import getConfig from 'next/config';

const {
  publicRuntimeConfig: {
    GF_DOTCOM_ECOMM_CORE_ENDPOINT,
    GF_DOTCOM_ENDPOINT,
    GF_DOTCOM_USE_DEV_PROXY,
  },
} = getConfig();

const endpoint = GF_DOTCOM_USE_DEV_PROXY === 'true'
  ? GF_DOTCOM_ENDPOINT
  : GF_DOTCOM_ECOMM_CORE_ENDPOINT || '';

/**
 * Helper to access ecomm-core apis.
 * In local development, ecomm-core lives on a different domain/port.
 * In deployed environments, ecomm-core likely lives on the same domain.
 * Includes credentials in call for auth. Can override with options object.
 * @param {String} route Ecomm Core API route. Should have leading slash.
 * @param {Object} options Options to pass to fetch. See fetch spec for
 *                         more details. https://github.com/github/fetch
 */
export default async function fetchEcomm(route, options = {}) {
  // Currently the ecomm API does not use auth tokens.  This is because
  // it is only used for referral logic, which depends on cookies being set.
  // In theory we are going to migrate to a 3P referral system and this will
  // go away then.  If if ends up blocking the user-service rails6 update we
  // might need a new plan.
  // See fetchReferralInfo in api/storefront for more details.
  // return fetchApi(`${endpoint}${route}`, options);

  const res = await fetch(`${endpoint}${route}`, {
    credentials: 'include',
    ...options,
  });
  return res.json();
}
